import React from 'react'
import { Button } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import fire from "../../Fire"
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import {Link} from "react-router-dom";
import swal from 'sweetalert';
export default function Sign() {
const [email,setEmail] = useState("");
const [password,setPassword] = useState("");
const [user,setUser] = useState("");
let history =useHistory();
const handleSubmit = (event)=>{
  event.preventDefault()
  console.log(user)
  fire.firestore().collection("users").add({
    user:user,
   
   })
  fire.auth().createUserWithEmailAndPassword(email,password)
  .then(()=>{
    swal("Good job!", "You clicked the button!", "success");
    })
    .then(()=>{
      history.push("/log")
    })
    .catch((error)=>{
      alert(error)
    })
   
}
    return (
        <div>
          <div className="container" style={{padding:70}}>
            <div className="row justify-content-center align-items-center">
              <div className="col-md-6">
              <Form onSubmit={handleSubmit}>
           
            <Form.Group className="mb-3" controlId="formBasicEmail">
    <Form.Label>UserName</Form.Label>
    <Form.Control type="text" placeholder="Enter UserName" onChange={(ev)=>setUser(ev.target.value)} required/>
  </Form.Group>
  <Form.Group className="mb-3" controlId="formBasicEmail">
    <Form.Label>Email address</Form.Label>
    <Form.Control type="email" placeholder="Enter email" onChange={(ev)=>setEmail(ev.target.value)} required/>
  </Form.Group>

  <Form.Group className="mb-3" controlId="formBasicPassword">
    <Form.Label>Password</Form.Label>
    <Form.Control type="password" placeholder="Password" onChange={(ev)=>setPassword(ev.target.value)} required/>
  </Form.Group>
 <Link style={{color:'white',fontWeight:'bold'}} to="/log">Already Account Go Login</Link> <br /><br />
  <Button variant="dark" type="submit">
    Sign In
  </Button>
</Form>
</div>
<div className="col-md-6 justify-content-center align-items-center">
  <img width="500" src="https://d1idiaqkpcnv43.cloudfront.net/website1.0/images/sign-up.png" alt="" />
</div>
</div>
</div>
        </div>
    )
}

